import React, { useEffect, useState } from 'react'

import { styled } from '@linaria/react'
import { FormattedMessage } from 'react-intl'
import { useLocation } from 'react-router'

import { BlogLink } from 'components/block/BlogLink/BlogLink'
import { CreateProfileOrLoginBlockInner } from 'components/block/Navigation/CreateProfileOrLoginBlockInner'
import { SecondaryButton } from 'components/designSystem/Button/SecondaryButton'
import { breakpoints } from 'components/designSystem/shared/breakpoints'
import { ContactSideBarLoadable } from 'components/page/ContactList/ContactSideBarLoadable'
import { contactListPath, logoutPath } from 'components/paths'
import { useHasUserRestrictions } from 'functions/hasUserRestrictions'
import { isShowLeftLayoutNext } from 'functions/isShowLeftLayout'
import { mergeAllUrls } from 'functions/mergeAllUrls'
import { useAuthorized } from 'hooks/useAuthorized'
import { useLayoutContext } from 'hooks/useLayoutContext'
import { useMambaPartner } from 'hooks/useMambaPartner'

export const SidebarSwitch = () => {
  const authorized = useAuthorized()
  const { pathname } = useLocation()
  const hasRestrictions = useHasUserRestrictions()
  const { baseUrl } = useLayoutContext()
  const [aside, setAside] = useState(isShowLeftLayoutNext())
  const isMamba = useMambaPartner()

  useEffect(() => {
    const handleResize = () => setAside(isShowLeftLayoutNext())
    window.addEventListener('resize', handleResize)
    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  if (!authorized) {
    return (
      <ParentSimple>
        <CreateProfileOrLoginBlockInner variant="block" />
        {isMamba && <BlogLink />}
      </ParentSimple>
    )
  }

  if (aside) {
    if (hasRestrictions) {
      return (
        <ParentSimple>
          <SecondaryButton
            to={mergeAllUrls(baseUrl, logoutPath)}
            fullWidth={true}
            size="M"
            data-name="link-logout-action"
          >
            <FormattedMessage
              id="form.button.logout_from_profile"
              defaultMessage="Выйти из профиля"
            />
          </SecondaryButton>
        </ParentSimple>
      )
    }

    if (authorized && !pathname.startsWith(contactListPath)) {
      if (isMamba) {
        return (
          <ParentContact>
            <ParentContactList>
              <ContactSideBarLoadable />
            </ParentContactList>
            <BlogLink />
          </ParentContact>
        )
      }
      return (
        <ParentContactFull>
          <ParentContactList>
            <ContactSideBarLoadable />
          </ParentContactList>
        </ParentContactFull>
      )
    }
  }

  return null
}

const ParentContact = styled.div`
  display: grid;
  grid-template-rows: 1fr auto;
  gap: var(--spacing-16px);
  grid-gap: var(--spacing-16px);
  min-width: 100%;

  /**
    * var(--spacing-48px) - высота  навигации
    * var(--spacing-24px) - отступ сверху у навигации
    * var(--spacing-16px) * 2 - отступ снизу у навигации и основного контента
    * var(--spacing-32px) - отступ снизу у основного контента
  */
  @media screen and (min-width: ${breakpoints.startDesktop}px) {
    height: calc(
      100vh - var(--spacing-48px) - var(--spacing-24px) - var(--spacing-16px) *
        2 - var(--spacing-32px)
    );
  }

  /**
    * var(--spacing-48px) - высота  навигации
    * var(--spacing-64px) - отступ сверху у навигации
    * var(--spacing-16px) * 2 - отступ снизу у навигации и основного контента
    * var(--spacing-80px) - отступ снизу у основного контента
  */
  @media screen and (min-width: ${breakpoints.largeDesktop}px) {
    height: calc(
      100vh - var(--spacing-48px) - var(--spacing-64px) - var(--spacing-16px) *
        2 - var(--spacing-80px)
    );
  }
`

const ParentContactFull = styled(ParentContact)`
  grid-template-rows: auto;
`

const ParentContactList = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100%;
`

const ParentSimple = styled.div`
  display: grid;
  grid-auto-flow: row;
  height: fit-content;
  width: 100%;
  gap: var(--spacing-32px);
  grid-gap: var(--spacing-32px);
`
